/* eslint-disable jsx-a11y/anchor-is-valid */
import useUsuario from 'hooks/useUsuario';
import React, { useMemo } from 'react';
import { Modal } from 'react-bootstrap';

const ModalBanner = ({ label = '', showModal, onCloseModal, objBanners = {} }) => {
  const usuario = useUsuario();

  const url = useMemo(() => {
    if (usuario.isDTC) {
      return objBanners?.dtc;
    }
    if (usuario.isAgente) {
      return objBanners.agente;
    }
  }, [usuario, objBanners]);

  return (
    <React.Fragment>
      <Modal show={showModal} onHide={onCloseModal} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
          <h2 className="text-mex">{label}</h2>
        </Modal.Header>
        <Modal.Body>
          <img src={url} style={{ width: '100%' }} />
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary" onClick={onCloseModal}>
            Cerrar
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default ModalBanner;
